import React from 'react';
import { Outlet } from 'react-router-dom';
import { ThemeProvider } from '@/contexts/ThemeContext';
import { NavigationProvider } from '@/contexts/NavigationContext';

/**
 * Implements theme management, navigation tracking, and provides the root layout for all pages.
 */
const App: React.FC = () => {
    return (
        <ThemeProvider>
            <NavigationProvider>
            <Outlet />
            </NavigationProvider>
        </ThemeProvider>
    );
};

export default App;